// packages
import { h } from 'preact';
import * as d3 from 'd3';
import createBase from '../utils/d3-base';

// data
import unemploymentRateSnapshots from '../../../data/map/county_unemployment_map_all_snapshots.json';

// components
import PureComponent from './PureComponent';

class MiniScale extends PureComponent {
  constructor() {
    super();

    this.getContainerWidth = this.getContainerWidth.bind(this);
    this.createChart = this.createChart.bind(this);
    this.redrawChart = this.redrawChart.bind(this);

    this.state = {
      containerWidth: null,
      bodyWidth: null,
      breakPoint: 544,
    };
  }

  createChart() {
    let { containerWidth, bodyWidth, breakPoint } = this.state;

    // get all the snapshots
    let data = unemploymentRateSnapshots;
    let dataArray = data.map(d => d.value);

    let color = d3
      .scaleQuantize()
      .nice()
      .range([
        '#edf6f7',
        '#c3e1e7',
        '#84c0ce',
        '#3a9bb1',
        '#267a8c',
        '#0a4b56',
      ]);

    // Establishes as isMobile function
    const isMobile = bodyWidth < breakPoint;

    // sets chartWidth
    let chartWidth = isMobile ? containerWidth : containerWidth / 3;
    let chartHeight = 65;

    // uses `./utils/d3-base` to set up a bunch of conventional d3 stuff
    const map = createBase({
      container: d3.select('.mini-scale'), // the chart container
      width: chartWidth,
      height: chartHeight,
    });

    // Create svg for the map
    const svg = map.g.append('g').attr('class', 'g_rate_scale');

    const numberOfClasses = color.range().length - 1;

    // get the extent of data to find a range for domain
    let dataRange = d3.extent(dataArray);

    let x_legend = d3
      .scaleLinear()
      .rangeRound([map.width * 0.1, map.width * 0.9]);

    // Establish the domain
    color.domain(dataRange);
    // how to get the thresholds for a bucket:
    // console.log('first bucket', color.invertExtent('#edf6f7'));
    // console.log('last bucket', color.invertExtent('#0a4b56'));

    // x_legend.domain(ckmeansBreaks);
    x_legend.domain(dataRange);

    const legend = svg
      .append('g')
      .attr('class', 'legend')
      .attr('transform', 'translate(0, 10)');
    const rate_legend = legend
      .append('g')
      .attr('class', 'rate_legend')
      .attr('transform', 'translate(0, 15)');

    // Creates legend based on rate data
    const legend_rect_width =
      (x_legend.range()[1] - x_legend.range()[0]) / numberOfClasses;

    legend
      .append('g')
      .attr('class', 'tick')
      .append('g')
      .attr('transform', 'translate(0, 5)')
      .append('text')
      .text('Unemployment rate');

    rate_legend
      .selectAll('rect')
      .data(
        color.range().map(function(d) {
          d = color.invertExtent(d);
          if (d[0] == null) d[0] = 0;
          return d;
        })
      )
      .enter()
      .append('rect')
      .attr('height', 10)
      .attr('x', (d, i) => i * legend_rect_width)
      .attr('width', () => legend_rect_width) // + 2
      .attr('fill', d => color(d[0]));

    // set ticks for the legend
    rate_legend
      .call(
        d3
          .axisBottom(x_legend)
          .tickSize(15)
          .tickFormat((d, i) =>
            i
              ? parseFloat(color.invertExtent('#0a4b56')[0].toFixed(1)) + '%+'
              : parseFloat(color.invertExtent('#edf6f7')[1].toFixed(1)) + '%'
          )
          .tickValues([
            color.invertExtent('#edf6f7')[0] + 1.5,
            color.invertExtent('#0a4b56')[0] + 0.85,
          ]) // placement of the ticks
      )
      .select('.domain')
      .remove();
  }

  redrawChart() {
    const { date } = this.props;

    d3.selectAll('.mini-scale svg').remove();

    let { containerWidth, bodyWidth } = this.getContainerWidth();
    this.setState({ containerWidth: containerWidth, bodyWidth: bodyWidth });

    this.createChart(date);
  }

  getContainerWidth() {
    let base = d3.select('.mini-scale-container');
    const body = d3.select('body');

    const containerWidth = base.node().offsetWidth;
    const bodyWidth = body.node().offsetWidth;

    return { containerWidth, bodyWidth };
  }

  componentDidMount() {
    const { date } = this.props;
    let { containerWidth, bodyWidth } = this.getContainerWidth();

    this.setState(
      { containerWidth: containerWidth, bodyWidth: bodyWidth },
      () => {
        this.createChart(date);
      }
    );

    window.addEventListener('resize', () => {
      this.redrawChart();
    });
  }

  componentWillUnmount() {
    window.addEventListener('resize', () => {
      this.redrawChart();
    });
  }

  render() {
    return <div class="mini-scale"></div>;
  }
}

export default MiniScale;
